module.exports = new __parcel__URL__("Step_1.e56e97a7.jpg").toString();